(ns common.schema.entities.custom-field
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.data-types :as data-types]
   [common.schema.field-type :as field-type]
   [common.roles :as roles]
   [schema.core :as s]))

(def editor-types [:editor.type/multi-select])
(def filter-types [:filter.type/multiplier])
(def visibility-types
  [:in-use
   :not-in-use
   :in-use-disabled
   :not-in-use-blocked])

(defn- system-controlled
  [opts]
  (assoc opts :system-semantics su/system-controlled-optional-field-semantics))

(def DataType
  (s/enum (->> data-types/zapflow-data-types
               (keys)
               (vec))))

(s/defschema FieldSchema
  {;; field identifier
   :field/attribute s/Keyword
   :field/secondary-attribute s/Keyword
   :field/name s/Str
   ;; optionally shown in grid
   :field/short-name s/Str
   :field/data-type s/Keyword
   ;; cannot be imported - for instance EDN fields
   :field/not-importable? s/Bool
   ;; should be removed -> use calculated-field etc. instead
   :field/artificial? s/Bool
   ;; fields used by calculation functions -> if calc field is enabled, these should be enabled too
   :field/composite-attributes [s/Keyword]
   ;; entity types allowed in :data.type/ref-single or data.type/ref-multi fields
   :field/entity-types [s/Keyword]
   ;; default visual representation of the field
   :field/default-visibility {:editor (s/enum editor-types)
                              :gird   (s/enum editor-types)
                              :filter (s/enum filter-types)
                              :field-visibility (s/enum visibility-types)}
   ;; role based minium role needed to access a field
   :field/default-authorization {:access/read   (s/enum roles/roles)
                                 :access/write  (s/enum roles/roles)
                                 :access/create (s/enum roles/roles)}
   ;; function -> {s/Keyword s/Any} -> merged to the field schema, hack - this should be handled in field specific base-multiplier etc
   :field/custom-params s/Any

   ;; a :field/attribute reference to "data state" attribute -> this is an aggregate field source
   :field/aggregate-attribute s/Keyword

   ;; ^^ function for resolving specific field from aggregate value
   :field/particular-value s/Any

   ;; function -> returns calculation result
   :field/calculated-field s/Any

   ;; constraint map -> better schema def needed
   :field/constraints {s/Keyword s/Any}

   ;; optional value when creating entity -> this will be deprecated when configuration for entity field is created
   :field/create-visibility (s/enum [:create.visibility/optional])

   ;; ^^ should be refactored to use above
   :field/not-shown-in-create? s/Bool

   ;; can be potentially refactored out ?
   :field/custom-sort s/Bool
   ;; deprecated -> should be refactored out
   :field/default-ord s/Num

   ;; WTF? - a bug ? what is the idea here ?
   :field/default-visibilty s/Any

   ;; Not used ? - Can this be removed ?
   :field/export-type DataType

   ;; System level config to hide certain fields from configurations ->> potentially combinable with other meta
   :field/hidden-from-configuration? s/Bool

   ;; Hides field from webform config -> mostly system entered fields like passed-on etc.
   :field/hide-from-webform? s/Bool

   ;; function -> truthy -> used for filtering certain fields from view -> i.e. there is only 1 pipeline, pipeline selector is hidden etc...
   :field/in-use-for-this-data? s/Any

   ;; indicated this field should be used for calculating :common/lower-case-str value -> there must be only 1 per entity
   :field/lower-case-str? s/Bool

   ;; reference to a field attribute that defines the name of this entity -> used for display-string
   :field/name-attribute s/Keyword

   ;; Definition if a field is mandatory - partial mandatory for instance if passed etc
   :field/mandatory (s/enum [:mandatory/always :mandatory/partially])

   ;; field cannot be cleared, but can be edited
   :field/not-clearable? s/Bool

;; These should be RENAMED! they are not application field attributes
   :field/value s/Any
   :field/key s/Any
   :field/disabled? s/Bool
   ;; function -> s/Any - not used ?
   :field/default-order s/Any
   ;; function -> s/Any -> filter options for specific entity
   :field/option-filter-fn s/Any

;; SHOULD BE renamed -> this is used only by front-end to show an icon in field header or something
   :field/label-icon s/Any
   :field/label-icon-tooltip s/Str})

(def schema
  (concat (su/text-simple-field :field/name
                                "Label"
                                {:authorization su/access-admin-ssg
                                 :default-field-visibility :in-use-disabled})
          (su/text-simple-field :field/short-name
                                "Short name"
                                {:authorization su/access-admin-ssg
                                 :default-field-visibility :in-use-disabled})
          (su/keyword-field :field/attribute
                            "Attribute"
                            nil
                            {:authorization su/access-admin-ssg
                             :default-field-visibility :in-use-disabled})
          (su/keyword-field :field/data-type
                            "Data type"
                            data-types/options
                            {:authorization su/access-admin-ssg
                             :default-field-visibility :in-use-disabled})
          (su/keyword-field :field/field-type
                            "Field type"
                            field-type/field-options
                            {:authorization su/access-admin-ssg
                             :default-field-visibility :in-use-disabled})
          ;; Which entity-type(s) the field belongs to
          (su/keyword-multi-field :field/for-entity-types
                                  "Entity types"
                                  nil
                                  (system-controlled {:authorization            su/access-system-ssg
                                                      :default-field-visibility :in-use-disabled}))
          ;; The entity-type(s) the value should be if field data-type is
          ;; :data.type/ref-multi or :data.type/ref-single
          ;; (only [:entity.type/named-value] for now)
          (su/keyword-multi-field :field/entity-types
                                  "Value entity types"
                                  nil
                                  (system-controlled {:authorization            su/access-system-ssg
                                                      :default-field-visibility :in-use-disabled}))
          (su/keyword-field :field/secondary-attribute
                            "Secondary attribute"
                            nil
                            (system-controlled {:authorization            su/access-system-ssg
                                                :default-field-visibility :in-use-disabled}))
          (su/keyword-field :field/related-fields
                            "Related attribute"
                            nil
                            (system-controlled {:authorization            su/access-system-ssg
                                                :default-field-visibility :in-use-disabled}))))
